import { ContextNonprofit } from "src/context/NonprofitsContext/types";

export function getOrganizationProfileFacts(nonprofit: ContextNonprofit) {
  return {
    name: nonprofit.name,
    slug: nonprofit.primarySlug,
    description: nonprofit.description,
    descriptionLong: nonprofit.descriptionLong,
    websiteUrl: nonprofit.websiteUrl,
    locationAddress: nonprofit.locationAddress,
    hasLogo:
      nonprofit.logoCloudinaryId === undefined
        ? undefined
        : !!nonprofit.logoCloudinaryId,
    hasCoverImage:
      nonprofit.coverImageCloudinaryId === undefined
        ? undefined
        : !!nonprofit.coverImageCloudinaryId,
    instagram: nonprofit.instagramHandle,
    facebook: nonprofit.facebookHandle,
    linkedIn: nonprofit.linkedInHandle,
    twitter: nonprofit.twitterHandle,
    youtube:
      nonprofit.youtubeHandle !== undefined
        ? nonprofit.youtubeHandle
        : nonprofit.youtubeUrl,
    bluesky: nonprofit.blueskyHandle,
    tiktok: nonprofit.tiktokHandle,
  };
}

// The backend computes milestones (GET /nonprofits/:id/admin); they are only
// on the store's nonprofit for its admins, after the admin page loads.
export function getOrganizationContext(nonprofit: ContextNonprofit) {
  return {
    facts: getOrganizationProfileFacts(nonprofit),
    milestones: nonprofit.milestones ?? [],
    nonprofit: {
      id: nonprofit.id,
      disbursement: { method: nonprofit.disbursementType },
    },
  };
}
